import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { UserService } from "../../shared/service/user.service";
import { EmployeeService } from "../../shared/service/employee.service";
import { FileUploadService } from "../../shared/service/fileUpload.service";
import { ToastrService } from "ngx-toastr";
import { OnboardingService } from "../../shared/service/onboarding.service";
import { isNullOrUndefined, isUndefined } from "util";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Skillset } from "../../shared/models/hremployeecommunicationdetails.model";
import { BasicEmployeeDetails } from "../../shared/models/basicemployeedetails.model";
import { Streams } from "../../shared/models/Streams";
import { PrimarySkills } from "../../shared/models/PrimarySkills";
import {
  TechGroupDialog,
  TechgroupDialogComponent,
} from "../../shared/components/techgroup-dialog/techgroup-dialog.component";
import { DepartmentsService } from "../../shared/service/departments.service";
import { MatDialog, MatSelect } from "@angular/material";
import { AdditionalSkills } from "../../shared/models/AdditionalSkills";
import {
  ConfirmDialogComponent,
  ConfirmDialogModel,
} from "../../shared/components/confirm-dialog/confirm-dialog.component";
import {
  ExpDialog,
  ExpertiseDialogComponent,
} from "../../shared/components/expertise-dialog/expertise-dialog.component";

@Component({
  selector: "app-skill-set",
  templateUrl: "./skill-set.component.html",
  styleUrls: ["./skill-set.component.css"],
})
export class SkillSetComponent implements OnInit {
  @Input() empCode: number;
  @Input() groupId: string;
  @Output("employeeSkillset") employeeSkillset = new EventEmitter();
  error: any;
  LoginEmpCode: any;
  isProfile: boolean;
  approveCheckMyProfile: any;
  disableforMyProfile: boolean;
  isLoader: boolean = true;
  Skillsetform: FormGroup;
  skillsetDetails: any;
  gettingBasicDet: BasicEmployeeDetails;
  techGroupList: any;
  TechGroupId: any;
  StreamId: any;
  RequiredTech: boolean = false;
  PrimarySkillId: any;
  filteredTechList: any;
  StreamList: Streams[] = [];
  PrimarySkillsList: PrimarySkills[] = [];
  AdditionalSkillsList: AdditionalSkills[] = [];
  filteredStreams: any;
  filteredPrimarySkills: any;
  filteredSecondarySkills: any;
  additionalSkills: FormArray = this.fb.array([]);
  filteredAdditionalSkills: any[] = [];
  previousTechGroupId: any;
  hasAddPermission = false;
  teamList: any;
  @ViewChild("streamSelect", { static: false }) streamSelect: MatSelect;
  @ViewChild("techGroupSelect", { static: false }) techGroupSelect: MatSelect;
  @ViewChild("primarySkillSelect", { static: false })
  primarySkillSelect: MatSelect;
  isTeamRequired: boolean;

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    public router: Router,
    public _service: OnboardingService,
    public toastr: ToastrService,
    public file_Svc: FileUploadService,
    private emp_Svc: EmployeeService,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private deptSvc: DepartmentsService,
    private cdr: ChangeDetectorRef
  ) {
    this.route.params.subscribe((params) => {
      this.empCode = params["empCode"];
      this.initializeParamChange();
    });
  }
  initializeParamChange() {
    //get the login employee code
    this.LoginEmpCode = this.userService.getEmpCode().toString();
    if (!isNullOrUndefined(this.empCode)) {
      if (this.router.url.startsWith("/myprofile/")) {
        if (this.empCode === this.LoginEmpCode) this.isProfile = true;
        else this.router.navigate(["/EmployeeWithoutPermission"]);
      }
    }
  }

  ngOnInit() {
   // this.getSubmitMyProfileData();
    this.checkPermission();
    setTimeout(() => {
      this.isLoader = false;
    }, 1500);
  }

  getSubmitMyProfileData() {
    this.emp_Svc
      .GetProfileVerificationStatus(this.LoginEmpCode)
      .subscribe((data: any) => {
        this.approveCheckMyProfile = data;
        if (this.isProfile == true) {
          for (var i = 0; i < data.length; i++) {
            this.disableforMyProfile = data[i].Submitted;
          }
        }
        if (this.disableforMyProfile == true) {
          this.Skillsetform.disable();
        }
      });
  }

  addItem(item = null) {
    if (item != null) {
      var row = this.fb.group({
        Id: [item.Id],
        EmpCode: [item.EmpCode],
        TechGroupId: [item.TechGroupId],
        SkillId: [item.SkillId],
        CreatedBy: [item.CreatedBy],
        CreatedDate: [item.CreatedDate],
        ModifiedBy: [item.ModifiedBy],
        ModifiedDate: [item.ModifiedDate],
      });
    } else {
      var row = this.fb.group({
        Id: [null],
        EmpCode: [null],
        TechGroupId: [null],
        SkillId: [null],
        CreatedBy: [null],
        CreatedDate: [null],
        ModifiedBy: [null],
        ModifiedDate: [null],
      });
    }
    this.additionalSkills.push(row);
  }



  deleteItem(index) {
    const message = `Please confirm if you want to delete this record?`;
    var deleteType = "Record";
    const dialogData = new ConfirmDialogModel(" ", message, deleteType);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.additionalSkills.value.splice(index, 1);
          var array = this.additionalSkills.value;
          this.additionalSkills.clear();
          for (var i = 0; i < array.length; i++) {
            this.onSelectionChange(i, array[i].TechGroupId);
            this.addItem(array[i]);
          }
          this.cdr.detectChanges();
          this.skillsetDetails.employeeAdditionalSkills =
            this.additionalSkills.value;
          this.employeeSkillset.emit(this.skillsetDetails);
        }
      },
      (error) => {
        this.error = error;
      }
    );
  }

  ngOnChanges() {
    this.skillsetDetails = new Skillset();
    this.GetTechGroup();
    this.getTeams();
    this.getStreams();
    this.getPrimarySkills();
    this.getAdditionalSkills();
    this.FormInitialization();
    if (!isUndefined(this.groupId)) {
      this.getBasicEmployeeByGroupId();
      this.getSkillsetDataByGroupId();
    }
    if (!isUndefined(this.empCode)) {
      this.getSkillsetData();
    } else {
      this.getBasicEmployeeByCode();
      this.employeeSkillset.emit(this.skillsetDetails);
    }
  }
  FormInitialization() {
    this.additionalSkills = this.fb.array([]);
    this.Skillsetform = new FormGroup({
      TechGroupId: new FormControl(),
      StreamId: new FormControl(),
      PrimarySkillId: new FormControl(),
      additionalSkills: this.additionalSkills,
    });
  }

  checkPermission() {
    var permission = this.userService.userInfo.permissions.find(
      (i) => i.Menu === "Master"
    );
    this.hasAddPermission =
      permission != null
        ? permission.AddingPermission || permission.HasFullAccess
        : false;
  }

  private updatePrimarySkillValidation(streamId: any) {
    const primarySkillControl = this.Skillsetform.get("PrimarySkillId");

    if (streamId) {
      primarySkillControl.setValidators([Validators.required]);
    } else {
      primarySkillControl.clearValidators();
    }

    // Update the validation state of the PrimarySkill control
    primarySkillControl.updateValueAndValidity();
  }
  GetTechGroup(val?: any) {
    this.deptSvc
      .getMasterGroupByCategory("TechGroup")
      .subscribe((data: any) => {
        this.RequiredTech = true;
        //this.techGroupList = [...data];
        //this.filteredTechList = data;
        data =
          (data &&
            data.filter(
              ({ IsTechGroupActive }) => (IsTechGroupActive === true)
            )) ||
          [];
        this.techGroupList = [...data].sort((a, b) =>
          a.GroupName.localeCompare(b.GroupName)
        );
        this.filteredTechList = data.sort((a, b) =>
          a.GroupName.localeCompare(b.GroupName)
        );
        if (val != null) {
          this.filteredTechList = this.techGroupList.filter(
            (tech) => tech.GroupName == val
          );
        }
      });
  }

  onSelectedTechGroupId() {
    if (this.skillsetDetails.TechGroupId != null) {
      this.skillsetDetails.StreamId = null;
      this.StreamId = null;
      this.PrimarySkillId = null;
      this.skillsetDetails.PrimarySkillId = null;
      this.filteredStreams = this.StreamList.filter(
        (stream) => stream.TeachGroupId == this.skillsetDetails.TechGroupId
      );
      if (this.filteredStreams.length === 1) {
        this.skillsetDetails.StreamId = this.filteredStreams[0].StreamName;
        this.StreamId = [this.filteredStreams[0].StreamName];
        this.onSelectedStream();
      }
    }
  }

  onSkillSelectionChange(index: number, value: any) {
    if (value != null) {
      const skillIdControl = this.additionalSkills!.at(index)!.get('SkillId');

      const selectedSkillIds = skillIdControl.value || [];

      let list = [], nonlist = [];

      this.filteredAdditionalSkills[index].forEach((skill) => {
        if (selectedSkillIds.includes(skill.ID)) {
          list.push(skill);
        } else {
          nonlist.push(skill);
        }
      });
      this.filteredAdditionalSkills[index] = [...list, ...nonlist];
    }
  }


  onSelectionChange(index, value) {
    if (value != null) {
      this.filteredAdditionalSkills[index] = this.AdditionalSkillsList.filter(
        (skill) => skill.TeachGroupId == value
      );

    }
  }



  sendDetails() {
    this.skillsetDetails.employeeAdditionalSkills = this.additionalSkills.value;
    return this.skillsetDetails;
  }

  onSelectedStream(event?: any) {
    if (this.StreamId != null)
      this.StreamId = this.StreamId.filter((item) => item !== undefined);
    if (this.StreamId && this.StreamId.length > 0) {
      this.skillsetDetails.StreamId = this.StreamId.join(",");
      this.skillsetDetails.PrimarySkillId = null;
      const selectedStreamIds = this.StreamId.map((streamName) => {
        const selectedStream = this.filteredStreams.find(
          (stream) => stream.StreamName === streamName
        );
        return selectedStream ? selectedStream.ID : null;
      }).filter((id) => id !== null);
      this.filteredPrimarySkills = this.PrimarySkillsList.filter((skill) => {
        return (
          skill.TeachGroupId === this.skillsetDetails.TechGroupId &&
          selectedStreamIds.includes(skill.StreamId)
        );
      });
    } else if (
      this.StreamId == null ||
      this.StreamId == "" ||
      this.StreamId == 0
    ) {
      this.filteredStreams = this.StreamList.filter(
        (stream) => stream.TeachGroupId == this.skillsetDetails.TechGroupId
      );
      this.skillsetDetails.StreamId = null;
      this.StreamId = null;
      this.PrimarySkillId = null;
      this.skillsetDetails.PrimarySkillId = null;
    }
  }

  onStreamChange(event) {
    if (event.option.value != "") {
      this.skillsetDetails.StreamId = event.option.id;
      this.onSelectedStream();
    }
  }

  onSelectedPrimarySkill() {
    if (this.PrimarySkillId != null && this.PrimarySkillId.length > 0) {
      this.PrimarySkillId = this.PrimarySkillId.filter(
        (item) => item !== undefined
      );
      this.skillsetDetails.PrimarySkillId = this.PrimarySkillId;
      this.PrimarySkillId = this.PrimarySkillId.filter((skillId) =>
        this.filteredPrimarySkills.some((skill) => skill.ID === skillId)
      );
      this.skillsetDetails.PrimarySkillId = this.PrimarySkillId;

      const list = this.filteredPrimarySkills.filter(({ ID }) => this.PrimarySkillId.includes(ID)).sort((a, b) => this.PrimarySkillId.indexOf(b.Name) - this.PrimarySkillId.indexOf(a.Name));
      const nonList = this.filteredPrimarySkills.filter(({ ID }) => !this.PrimarySkillId.includes(ID))
      this.filteredPrimarySkills = [...list, ...nonList]
      //this.filteredPrimarySkills = this.filteredPrimarySkills.sort((a, b) => this.PrimarySkillId.indexOf(b.ID) - this.PrimarySkillId.indexOf(a.ID));
    }
  }

  async AddExpertise(type) {
    var message;
    if (type == "Stream") message = `Add New Stream`;
    else if (type == "Techgroup") message = `Add New Techgroup`;
    else message = `Add New Primary Skill`;
    var techgroups = this.techGroupList;
    var streamList = this.StreamList;
    var primarySkillsList = this.PrimarySkillsList;
    if (this.streamSelect && this.streamSelect.panelOpen) {
      this.streamSelect.close();
    }
    if (this.techGroupSelect && this.techGroupSelect.panelOpen) {
      this.techGroupSelect.close();
    }
    if (this.primarySkillSelect && this.primarySkillSelect.panelOpen) {
      this.primarySkillSelect.close();
    }
    const dialogDataExp = new ExpDialog(
      "Action",
      message,
      techgroups,
      streamList,
      primarySkillsList,
      type
    );
    const dialogRefExp = this.dialog.open(ExpertiseDialogComponent, {
      width: "max-content",
      data: dialogDataExp,
    });

    dialogRefExp.afterClosed().subscribe(
      (dialogResultExp) => {
        if (dialogResultExp != false) {
          this.GetTechGroup(this.TechGroupId);
          this.getStreams(this.StreamId);
          this.getPrimarySkills(this.PrimarySkillId);
        }
      },
      (error) => {
        this.error = error;
      }
    );
  }

  doFilterTech() {
    if (this.TechGroupId != undefined) {
      this.previousTechGroupId = this.TechGroupId;
    }
    if (this.TechGroupId == undefined) {
      this.TechGroupId = this.previousTechGroupId;
    }
    if (!isNullOrUndefined(this.TechGroupId) && this.TechGroupId != 0) {
      this.filteredTechList = this.filterTech(this.techGroupList);
      this.filteredStreams = this.StreamList.filter(
        (stream) => stream.TeachGroupId == this.skillsetDetails.TechGroupId
      );
      this.filteredSecondarySkills = this.AdditionalSkillsList.filter(
        (skill) => skill.TeachGroupId == this.skillsetDetails.TechGroupId
      );
    } else if (
      this.TechGroupId == null ||
      this.TechGroupId == "" ||
      this.TechGroupId == 0
    ) {
      this.filteredTechList = this.techGroupList;
      this.skillsetDetails.StreamId = null;
      this.StreamId = null;
      this.PrimarySkillId = null;
      this.skillsetDetails.PrimarySkillId = null;
    }
  }

  doFilterStream() {
    if (!isNullOrUndefined(this.StreamId)) {
      this.filteredStreams = this.filterTech(this.StreamList);
      this.filteredPrimarySkills = this.PrimarySkillsList.filter(
        (skill) =>
          skill.TeachGroupId == this.skillsetDetails.TechGroupId &&
          skill.StreamId == this.skillsetDetails.StreamId
      );
    }
  }

  onTech(event) {
    if (event.option.value != "") {
      this.skillsetDetails.TechGroupName = event.option.value;
      this.skillsetDetails.TechGroupId = event.option.id;
      this.onSelectedTechGroupId();
    }
  }

  filterTech(values) {
    return values.filter((value) =>
      value.GroupName.toLowerCase().includes(this.TechGroupId.toLowerCase())
    );
  }

  filterStream(values) {
    return values.filter((value) =>
      value.Value.toLowerCase().includes(this.StreamId.toLowerCase())
    );
  }

  getStreams(val?: any) {
    this.emp_Svc.getStreams().subscribe((data: any) => {
      //this.StreamList = data;
      //this.filteredStreams = data;
      this.StreamList = data.sort((a, b) =>
        a.StreamName.localeCompare(b.StreamName)
      );
      this.filteredStreams = data.sort((a, b) =>
        a.StreamName.localeCompare(b.StreamName)
      );
      if (val && val.length > 0) {
        this.filteredStreams = this.StreamList.filter(
          (stream) => stream.TeachGroupId == this.skillsetDetails.TechGroupId
        );
      }
    });
  }

  getPrimarySkills(val?: any) {
    this.emp_Svc.getPrimarySkills().subscribe((data: any) => {
      //this.PrimarySkillsList = data;
      //this.filteredPrimarySkills = data;
      this.PrimarySkillsList = data.sort((a, b) =>
        a.Name.localeCompare(b.Name)
      );

      this.filteredPrimarySkills = data.sort((a, b) =>
        a.Name.localeCompare(b.Name)
      );
      if (val && val.length > 0) {
        const selectedStreamIds = this.StreamId.map((streamName) => {
          const selectedStream = this.filteredStreams.find(
            (stream) => stream.StreamName === streamName
          );
          return selectedStream ? selectedStream.ID : null;
        }).filter((id) => id !== null);
        this.filteredPrimarySkills = this.PrimarySkillsList.filter((skill) => {
          return (
            skill.TeachGroupId === this.skillsetDetails.TechGroupId &&
            selectedStreamIds.includes(skill.StreamId)
          );
        });
      }
    });
  }

  getAdditionalSkills() {
    this.emp_Svc.getSecondarySkills().subscribe((data: any) => {
      //this.AdditionalSkillsList = data;
      //this.filteredSecondarySkills = data;
      //this.filteredAdditionalSkills[0] = data;
      this.AdditionalSkillsList = data.sort((a, b) =>
        a.Name.localeCompare(b.Name)
      );
      this.filteredSecondarySkills = data.sort((a, b) =>
        a.Name.localeCompare(b.Name)
      );
      this.filteredAdditionalSkills[0] = data.sort((a, b) =>
        a.Name.localeCompare(b.Name)
      );
    });
  }

  getBasicEmployeeByGroupId() {
    if (this.empCode != null) {
      this.emp_Svc
        .getEmployeeDetailsByGroupId(this.groupId)
        .subscribe((data: any) => {
          this.gettingBasicDet = data;
        });
    }
  }

  getBasicEmployeeByCode() {
    if (this.empCode != null) {
      this.emp_Svc.getBasicEmployeeById(this.empCode).subscribe((data: any) => {
        this.gettingBasicDet = data;
      });
    }
  }

  getSkillsetDataByGroupId() { }


  onSkillSelectionChangeBig(index: number, value: any) {
    if (value != null) {
      const selectedSkillIds = value || [];
      let list = [], nonlist = [];
      this.filteredAdditionalSkills[index].map((a) => {
        if (selectedSkillIds.includes(a.ID)) {
          list.push(a);
        } else {
          nonlist.push(a);
        }
      });
      this.filteredAdditionalSkills[index] = [...list, ...nonlist];
    }
  }



  getSkillsetData() {
    this.emp_Svc.getEmployeeById(this.empCode).subscribe((data: any) => {
      this.gettingBasicDet = data;
      this.additionalSkills = this.fb.array([]);
      this.Skillsetform = this.fb.group({
        TechGroupId: null,
        StreamId: null,
        PrimarySkillId: null,
        additionalSkills: this.additionalSkills,
      });
      this.skillsetDetails = data;
      this.cdr.detectChanges();
      //this.Skillsetform.patchValue({
      //  PrimarySkill: ['1','2'],
      //  StreamId: data.StreamId.split(","),
      //  TechGroupId: data.TechGroupName,
      //});
      this.techGroupList.forEach((item) => {
        if (item.ID == this.skillsetDetails.TechGroupId) {
          this.TechGroupId = item.GroupName;
        }
        this.cdr.detectChanges();
      });
      this.StreamId = data.StreamId != null ? data.StreamId.split(",") : data.StreamId;
      this.PrimarySkillId =
        data.PrimarySkillId != null
          ? data.PrimarySkillId.split(",").map((item) =>
            parseInt(item.trim(), 10)
          )
          : null;
      if (
        data.employeeAdditionalSkills != null &&
        data.employeeAdditionalSkills.length > 0
      ) {
        for (var i = 0; i < data.employeeAdditionalSkills.length; i++) {
          this.onSelectionChange(
            i,
            data.employeeAdditionalSkills[i].TechGroupId
          );
          this.onSkillSelectionChangeBig(
            i,
            data.employeeAdditionalSkills[i].SkillId
          );
          data.employeeAdditionalSkills[i].SkillId =
            data.employeeAdditionalSkills[i].SkillId.split(",").map((item) =>
              parseInt(item.trim(), 10)
            );
          this.addItem(data.employeeAdditionalSkills[i]);
        }
        this.cdr.detectChanges();
      } else {
        this.addItem();
      }
    });
    this.cdr.detectChanges();
  }

  getTeams() {
    this.deptSvc.fetchAndCacheEeTypeList('Team').subscribe((teamList) => {
      this.teamList = teamList.filter(
        (team) => team.Value != "Onshore"
      );
    });
  }

  getTeamValue(Id) {
    if (this.teamList != null) {
      for (var i = 0; i < this.teamList.length; i++) {
        if (this.teamList[i].ID == Id) {
          this.isTeamRequired = this.teamList[i].Value == "Offshore";
          return this.teamList[i].Value;
        }
      }
    }
  }

  get selectedPrimarySkills(): string {
    return this.PrimarySkillId
      ? this.PrimarySkillId
        .map(id => {
          const skill = this.filteredPrimarySkills.find(skill => skill.ID === id);
          return skill ? skill.Name : null;
        })
        .filter(name => name).sort()
        .join(', ') || 'No skills selected'
      : 'No skills selected';
  }
  getSelectedSkillNames(index: number): string {
    const selectedSkillIds = this.additionalSkills.value[index]!.SkillId || [];
    if (!this.filteredAdditionalSkills[index]) {
      return '';
    }
    const matchedSkills = this.filteredAdditionalSkills[index]
      .filter(skill => selectedSkillIds.includes(skill.ID))
      .map(skill => skill.Name);
    return matchedSkills.join(', ');
  }

}
